"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Replacement = function () {
  function Replacement(text, foundText) {
    this.foundText = foundText || '';
    this.text = text;
    this.range = {
      start: 0,
      end: 0
    };

    this.replaceFunction = function (offsetText) {
      return document.createTextNode(offsetText);
    };
  }

  Replacement.prototype.replace = function () {
    var _a = this.range,
        start = _a.start,
        end = _a.end;

    if (start === end) {
      return null;
    }

    var offsetText = this.text.slice(start, end);
    return this.replaceFunction(offsetText, this.foundText);
  };

  return Replacement;
}();

exports.Replacement = Replacement;